// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b00c8a25","239":"d43e3c31","453":"2148ab9b","732":"08f6deda"}[chunkId] + ".chunk.js";
};